import { CategoryModel } from 'src/types/category.model';
import CategoryService from 'src/services/category.service';
import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { TransactionType } from 'src/types/transaction-type.enum';

const categoriesQueryKey: string = 'categories';

export const useCategories = (transactionType?: TransactionType): UseQueryResult<CategoryModel[]> => {
    return useQuery<CategoryModel[]>({
        queryKey: [categoriesQueryKey, transactionType],
        queryFn: async () => await CategoryService.getCategories(transactionType)
    });
};

export const useCreateCategory = (): UseMutationResult<CategoryModel, unknown, string[]> => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ([categoryName, parentCategoryId]: string[]) => {
            const newCategory: CategoryModel = new CategoryModel();
            newCategory.name = categoryName;
            newCategory.parentId = parentCategoryId;
            return await CategoryService.createCategory(newCategory);
        },
        onSuccess: (): void => {
            void queryClient.invalidateQueries([categoriesQueryKey]);
        }
    });
};
